import htmlComponent from 'htmlcomponent'

export default function(dom, opts) {
	let options = {
		...opts
	};

	const html = document.documentElement;

	dom.addEventListener('click', e => {
		e.preventDefault();
		html.classList.toggle('show--nav');
	});
}
